<template>
  <div class="work-plan">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$lange == 'en' ? 'Work plan' : '工作计划'"
        name="plan"
      >
        <div class="plan">
          <div class="plan-title flex-between">
            <p class="flex-between">
              <span>{{ $lange == "en" ? "Project" : "项目" }}</span>
              <el-input
                size="mini"
                :placeholder="
                  $lange == 'en'
                    ? 'Please enter Project name'
                    : '请输入项目名称'
                "
                v-model="workPlanTableParams.workshopProjectName"
              ></el-input>
              <!--                            <el-select size="mini" placeholder="请选择" style="display: inline-block;">-->
              <!--                                <el-option label="全部项目" value=""></el-option>-->
              <!--                                <el-option label="进行中" value="0"></el-option>-->
              <!--                                <el-option label="已完成" value="1"></el-option>-->
              <!--                                <el-option label="延误" value="2"></el-option>-->
              <!--                            </el-select>-->
            </p>
            <p class="flex-between">
              <span>{{ $lange == "en" ? "Status" : "状态" }}</span>
              <el-select
                size="mini"
                v-model="workPlanTableParams.status"
                placeholder="请选择"
                style="display: inline-block"
                clearable
              >
                <el-option
                  :label="$lange == 'en' ? 'All' : '全部'"
                  value=""
                ></el-option>
                <el-option
                  :label="$lange == 'en' ? 'Not yet begun' : '未开始'"
                  :value="0"
                ></el-option>
                <el-option
                  :label="$lange == 'en' ? 'In operation' : '运行中'"
                  :value="1"
                ></el-option>
                <el-option
                  :label="$lange == 'en' ? 'Completed' : '已完成'"
                  :value="2"
                ></el-option>
                <el-option
                  :label="$lange == 'en' ? 'Delay' : '延期'"
                  :value="3"
                ></el-option>
              </el-select>
            </p>
            <p class="flex-between">
              <span>{{ $lange == "en" ? "Time" : "时间" }}</span>
              <!-- <span style="display: inline-block"> -->
              <el-date-picker
                size="mini"
                v-model="dateValue"
                value-format="yyyy-MM-dd"
                type="daterange"
                @change="timeChange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <!-- </span> -->
            </p>
            <p class="flex-between">
              <el-button type="primary" size="mini" @click="doSearch">{{
                $lange == "en" ? "Search" : "搜索"
              }}</el-button>
            </p>
          </div>
          <div class="table-box not-padding">
            <cc-table
              :config="workPlanTableConfig"
              :params="workPlanTableParams2"
            ></cc-table>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "DailyAllPlan",
  data() {
    return {
      activeName: "plan",
      dateValue: "",
      //工作计划表格
      workPlanTableConfig: {
        api: "admin/fsb/workshop/unit/query",
        pageSize: 10,
        showPager: true,
        columns: [
          {
            prop: "workshopProject.name",
            lable: this.$lange == "en" ? "Project" : "项目",
          },
          {
            prop: "name",
            lable: this.$lange == "en" ? "Unit" : "单元",
          },
          {
            prop: "workshopOrderNum",
            lable: this.$lange == "en" ? "Order number" : "订单数量",
          },
          {
            prop: "estimatedWorkingHours",
            lable:
              this.$lange == "en"
                ? "Estimated working hours"
                : "预计工时（小时）",
          },
          {
            prop: "actualWorkingHours",
            lable:
              this.$lange == "en" ? "Actual working hours" : "实际工时（小时）",
          },
          {
            prop: "schedule",
            lable: this.$lange == "en" ? "Productiveness" : "效率",
          },
          {
            prop: "limitHoursSchedule",
            lable: this.$lange == "en" ? "Speed of progress" : "进度",
          },
          {
            prop: "deptName",
            lable: this.$lange == "en" ? "Class" : "负责班级",
          },
          {
            lable: this.$lange == "en" ? "Scheduled to start" : "计划开始时间",
            render: (row) => {
              return moment(row.startTime).format("YYYY-MM-DD");
            },
            minWidth: 100,
          },
          {
            lable: this.$lange == "en" ? "Scheduled to finish" : "计划结束时间",
            render: (row) => {
              return moment(row.endTime).format("YYYY-MM-DD");
            },
            minWidth: 100,
          },
          {
            lable: this.$lange == "en" ? "Actual start time" : "实际开始时间",
            render: (row) => {
              return row.actualStartTime;
            },
            minWidth: 150,

          },
          {
            lable: this.$lange == "en" ? "Actual end time" : "实际结束时间",
            render: (row) => {
              return row.actualEndTime;
            },
            minWidth: 150,
          },
          {
            prop: "status",
            lable: this.$lange == "en" ? "Status" : "状态",
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "Not yet begun" : "未开始",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Have in hand" : "进行中",
              },
              {
                tagType: "success",
                text: this.$lange == "en" ? "Completed" : "已完成",
              },
              {
                tagType: "danger",
                text: this.$lange == "en" ? "Delay" : "延期",
              },
            ],
          },
        ],
      },
      workPlanTableParams: {
        startTime: "",
        endTime: "",
        status: "",
        workshopProjectName: "",
      },
      workPlanTableParams2: {
        startTime: "",
        endTime: "",
        status: "",
        workshopProjectName: "",
      },
    };
  },
  methods: {
    doSearch() {
      this.workPlanTableParams2 = { ...this.workPlanTableParams };
    },
    timeChange(res) {
      if (res) {
        this.workPlanTableParams.startTime = res[0];
        this.workPlanTableParams.endTime = res[1];
      } else {
        this.workPlanTableParams.startTime = "";
        this.workPlanTableParams.endTime = "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.project,
.plan {
  padding: 20px;
}

.table-box {
  margin-top: 20px;
}
.plan-title {
  justify-content: flex-start;
  padding: 5px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e4e4;
  > p {
    span {
      width: 35px;
      &:first-child {
        margin-right: 10px;
      }
    }

    &:not(:last-child) {
      margin-right: 30px;
    }
  }
}
</style>

